import { PUBLIC_URLS } from '@/configs/constants';

const is = Object.freeze({
  dev: () => process.env.NODE_ENV === 'development',
  server: () => typeof window === 'undefined',
  client: () => typeof window !== 'undefined',
  function: (fn: any) => fn && typeof fn === 'function',
  publicPath: (path: string) => PUBLIC_URLS.includes(path),
  array: (arr: any[]) => Array.isArray(arr),
  string: (param: any) => typeof param === 'string',
  object: (param: any) => typeof param === 'object',
  null: (param: any) => param === null,
  empty: {
    array: (arr: any[]) => !Boolean(arr && Array.isArray(arr) && arr.length !== 0),
    object: (ob: any) => typeof ob === 'object' && Object.keys(ob).length === 0,
    value: (value: any) => {
      const typeofVal = typeof value;
      if (typeofVal === 'string') {
        return value.length === 0;
      } else if (Array.isArray(value)) {
        return value.length === 0;
      } else if (typeofVal === 'object') {
        return Object.keys(value).length === 0;
      }
      return false;
    },
    string: (str: any) => typeof str === 'string' && str.length === 0,
  },
  not: {
    undefined: (param: any) => typeof param !== 'undefined',
    string: (param: any) => typeof param !== 'string' || param.length === 0,
    empty: {
      array: (arr: any) => Array.isArray(arr) && arr.length > 0,
      object: (ob: any) => typeof ob === 'object' && Object.keys(ob).length > 0,
      string: (param: any) => typeof param === 'string' && param.length > 0,
    },
    null: (param: any) => param !== null,
  },
  valid: {
    date: (dateString: Date) => !isNaN(dateString.getTime()),
    otp: (otp: string, boxNumber: number) => {
      if (!new RegExp('^[0-9]{' + boxNumber + '}$').test(otp)) {
        return false;
      }
      return true;
    },
  },
});

export default is;
